import { useState } from 'react';
import { connect } from 'react-redux';
import { format, subMonths } from 'date-fns';

import {
  Container,
  DateContainer,
} from '../styles';
import FilterContainer from '../../../../Tracking/components/NFFilters/components/FilterContainer';
import FilterForm from '../../../../Tracking/components/NFFilters/components/FilterForm';
import RangeDatePicker from '../../../../../components/RangeDatePicker';

const RangeDate = ({
  isOpen,
  onClick,
  onApply,
  value,
}) => {
  const [startDate, setStartDate] = useState(format(subMonths(new Date(), 1), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'));

  const resetState = () => {
    setStartDate(format(subMonths(new Date(), 1), 'yyyy-MM-dd'));
    setEndDate(format(new Date(), 'yyyy-MM-dd'));
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply({
      initialPeriod: startDate,
      finalPeriod: endDate,
      displayValue: '',
    });
  };

  const handleClearFilter = () => {
    resetState();
    onApply({
      initialPeriod: format(subMonths(new Date(), 1), 'yyyy-MM-dd'),
      finalPeriod: format(new Date(), 'yyyy-MM-dd'),
      displayValue: ''
    });
  };

  return (
    <FilterContainer label="Período" isOpen={isOpen} onClick={onClick} value={value}>
      <FilterForm label="Filtrar por período" onSubmit={handleSubmit} clearFilter={handleClearFilter}>
        <Container>
          <DateContainer>
            <RangeDatePicker
              startDate={startDate}
              endDate={endDate}
              onChangeStartDate={setStartDate}
              onChangeEndDate={setEndDate}
            />
          </DateContainer>
        </Container>
      </FilterForm>
    </FilterContainer>
  );
};

const mapStateToProps = state => ({
  initialPeriod: state.dashboardFilters.filters.initialPeriod,
  finalPeriod: state.dashboardFilters.filters.finalPeriod,
});

export default connect(mapStateToProps)(RangeDate);